import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import InternalApprovalEntity from "../../../Models/Approvals/InternalApprovalEntity";
import { Catalogue } from "@singularsystems/neo-react-services";
import { AppService, DomainTypes } from "../../../DomainTypes";

export default class InternalApprovalEntityCatalogueEntry extends CatalogueEntry<InternalApprovalEntity> {

    constructor() {
        super("Approval Entity", InternalApprovalEntity);
    }

    public get editRole() {
        return CatalogueRoles.AssetClass.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.internalApprovalEntities;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return AppService.get(DomainTypes.ApiClients.InternalApprover).saveInternalApprovalEntities;
    }
    
    public renderRow(item: InternalApprovalEntity, meta: Model.TransformMetaType<InternalApprovalEntity>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.alias} />
                <NeoGrid.Column bind={meta.entityName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}